import { Component, OnInit, TemplateRef } from '@angular/core';
import { EventsService } from '../services/events.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { Router } from '@angular/router';
import { EncrDecrService } from '../services/encr-decr.service';
import { MatButtonToggleChange } from '@angular/material/button-toggle';

@Component({
  selector: 'app-mycreatedevents',
  templateUrl: './mycreatedevents.component.html',
  styleUrls: ['./mycreatedevents.component.scss']
})
export class MycreatedeventsComponent implements OnInit {
  modalRef: BsModalRef;
  message: string;
  constructor(private eventService: EventsService,
    private modalService: BsModalService, private router: Router,
    private encDecrService: EncrDecrService) { }

  events: any;
  show = false;
  toggle = "created";
  maxLength = 100

  // Event Status
  EVENT_STATUS_CREATED = 'CREATED';
  EVENT_STATUS_APPROVED = 'APPROVED';
  EVENT_STATUS_REJECTED = 'REJECTED';
  EVENT_STATUS_ACTIVE = 'ACTIVE';
  EVENT_STATUS_CANCELD = 'CANCELLED';
  EVENT_STATUS_FINISHED = 'FINISHED';

  // Event Type
  EVENT_TYPE_STANDARD = 'STANDARD';
  EVENT_TYPE_FEATURED = 'FEATURED';
  EVENT_TYPE_SPONSORED = 'SPONSORED';

  createdEvents:any = [];
  approvedEvents:any = [];
  rejectedEvents:any = [];
  // activeEvents:any = [];
  cancelledEvents:any = [];
  finishedEvents:any = [];
 async ngOnInit() {
    await this.eventService.getMyEvents().then((res: any) => {
      if (res.success) {
        this.events = res.events.data;
        console.log(this.events)
        for(let i =0;i<this.events.length; i++){
          if(this.events[i].description.length>this.maxLength){
            this.checkDataLength(this.events[i]);
            this.events = this.events.map(item => ({
              ...item,
              // isReadMore:false,
              isCollapsed:true,
              // exceeded:true
            }));
          }
          
          }
         this.events = this.events.map(item => ({
        ...item,
        freeEvent:"Free"
      }));
      for (let i=0; i<this.events.length; i++){
        if ((this.events[i].min_fee == 0) && (this.events[i].max_fee == 0)){
          this.events[i].freeEvent = "Free"
        } else if ((this.events[i].min_fee != 0 && this.events[i].min_fee != null) && (this.events[i].max_fee != 0 && this.events[i].max_fee != null)){
          this.events[i].freeEvent = "Paid"
        }
        if(this.events[i].website == "" || this.events[i].website == null){
          this.events[i].noWebsite = false
        }
        else {
          this.events[i].noWebsite = true
        }
      //   if(this.events[i].category_list.length < 1 || this.events[i].category_list == undefined){
      //   } else {  
      //     for(let j=0;i<this.events[i].category_list.length; j++){
      //       this.events[i]
      //       this.events[i].categories[j] =  this.events[i].category_list[j].category.name
      //     // this.events[i].categories.push(this.events[i].category_list[j].category.name)
      //   }
      // }
      }
      }
    })
      .catch((error) => {
        console.log(error)
      })
      console.log(this.events)


      // Created Events
      for(let i=0;i<this.events.length; i++){
        if(this.events[i].status=="created"){
          this.createdEvents.push({
            events:this.events[i]
          })
        }
      }
      console.log("created",this.createdEvents)

      // Approved Events
      for(let i=0;i<this.events.length; i++){
        if(this.events[i].status=="approved"){
          this.approvedEvents.push({
            events:this.events[i]
          })
        }
      }
      // console.log("approved",this.approvedEvents)

      // Rejected Events
      for(let i=0;i<this.events.length; i++){
        if(this.events[i].status=="rejected"){
          this.rejectedEvents.push({
            events:this.events[i]
          })
        }
      }
      // console.log("rejected",this.rejectedEvents)

      // Cancelled Events
      for(let i=0;i<this.events.length; i++){
        if(this.events[i].status=="cancelled"){
          this.cancelledEvents.push({
            events:this.events[i]
          })
        }
      }
      // console.log("cancelled",this.cancelledEvents)

      // Finished Events
      for(let i=0;i<this.events.length; i++){
        if(this.events[i].status=="finished"){
          this.finishedEvents.push({
            events:this.events[i]
          })
        }
      }
      // console.log("finished",this.finishedEvents)

      // Active Events
      // for(let i=0;i<this.events.length; i++){
      //   if(this.events[i].status=="active"){
      //     this.activeEvents.push({
      //       events:this.events[i]
      //     })
      //   }
      // }
      // console.log("active",this.activeEvents)
  }

  checkDataLength(data) {
    console.log('string-length', data.description.length);
    for(let i =0;i<this.events.length; i++){
      if(this.events[i].id == data.id){
        if(data.description.length >= 100){
    this.events[i].isReadMore = true
  }
      }
    }
  }


  OnToggleChanged(ev) {
    console.log(ev);
  }
  toggleView(change: MatButtonToggleChange){
    this.toggle = change.value;
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, {class: 'modal-sm'});
  }

  confirm(): void {
    this.message = 'Confirmed!';
    this.modalRef.hide();
  }

  decline(): void {
    this.message = 'Declined!';
    this.modalRef.hide();
  }

  cancelEvent(item) {
    let status = item.status
   console.log(item)
    this.eventService.cancelEvent(item.id).then((res) => {
        console.log(res)
        if(status=="created"){
          let filterArray = this.createdEvents.filter(o =>o.events.id !== item.id)
        this.createdEvents = filterArray
        item.status="cancelled"
        this.cancelledEvents.push({events: item})
        }
        else if(status=="approved"){
          let filterArray = this.approvedEvents.filter(o =>o.events.id !== item.id)
        this.approvedEvents = filterArray
        item.status="cancelled"
        this.cancelledEvents.push({events: item})
        }
        else if(status=="finished"){
          let filterArray = this.finishedEvents.filter(o =>o.events.id !== item.id)
        this.finishedEvents = filterArray
        item.status="cancelled"
        this.cancelledEvents.push({events: item})
        }
        else if(status=="rejected"){
          let filterArray = this.rejectedEvents.filter(o =>o.events.id !== item.id)
        this.rejectedEvents = filterArray
        item.status="cancelled"
        this.cancelledEvents.push({events: item})
        }
        // this.getMyEvents()
        this.modalRef.hide();
      })
      .catch((error) => {

      })
  }
  goToUpdateEventPage(item){
    console.log(item)
    localStorage.setItem("editevent", JSON.stringify(item))
  }

  goToEventPage(item) {
    this.router.navigate(['event', item.link]);
  }

  navigate(url){
    window.open("https://"+url, "_blank")
  }

  checkComa(cat, i){
   if(cat.category_list.length !== i+1) return ", ";
   else return null
  }

}
